/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as Joi from 'joi-browser';

const InputSchema = {
    RecipientForm: {
        firstname: Joi.string()
            .trim()
            .max(50)
            .min(2)
            .required()
            .label('First Name'),
        lastname: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('Last Name'),
        relationship: Joi.any()
            .optional()
            .label('Relationship'),
        location: Joi.string()
            .required()
            .label('Location Type'),
        company: Joi.any()
            .when('location', {
                is: 'Business',
                then: Joi.string().required(),
                otherwise: Joi.any().optional(),
            })
            .label('Company Name'),
        street: Joi.string()
            .trim()
            .max(100)
            .min(2)
            .required()
            .label('Street Address'),
        apt: Joi.any()
            .optional()
            .label('Apt, Suite'),
        apofpo: Joi.any()
            .optional()
            .label('APO/FPO'),
        city: Joi.string()
            .trim()
            .max(50)
            .min(2)
            .required()
            .label('City'),
        state: Joi.string()
            .alphanum()
            .required()
            .label('State'),
        zipcode: Joi.string()
            .trim()
            .regex(/^[a-zA-Z0-9-\s]+$/i, 'alphanumeric characters')
            .min(5)
            .max(10)
            .required()
            .label('Zip Code'),
        country: Joi.string()
            .alphanum()
            .required()
            .label('Country'),
        phone: Joi.string()
            .regex(/^[0-9]{10}$/i, '10 numeric characters')
            .allow('')
            .label('Phone Number'),
        isbilling: Joi.boolean().required(),
        suggestedAddress: Joi.any().optional(),
    },
    BillingForm: {
        firstname: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('First Name'),
        lastname: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('Last Name'),
        relationship: Joi.any()
            .optional()
            .label('Relationship'),
        location: Joi.any()
            .optional()
            .label('Location Type'),
        company: Joi.any()
            .optional()
            .label('Company Name'),
        street: Joi.string()
            .trim()
            .max(100)
            .required()
            .label('Street Address'),
        apt: Joi.any()
            .optional()
            .label('Apt, Suite'),
        apofpo: Joi.any()
            .optional()
            .label('APO/FPO'),
        city: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('City'),
        state: Joi.string()
            .alphanum()
            .required()
            .label('State'),
        zipcode: Joi.string()
            .trim()
            .regex(/^[a-zA-Z0-9-\s]+$/i, 'alphanumeric characters')
            .min(5)
            .max(10)
            .required()
            .label('Zip Code'),
        country: Joi.string()
            .alphanum()
            .required()
            .label('Country'),
        phone: Joi.string()
            .regex(/^[0-9]{10}$/i, '10 numeric characters')
            .required()
            .label('Phone Number'),
        isbilling: Joi.boolean().required(),
        suggestedAddress: Joi.any().optional(),
    },
    GiftListRecipientForm: {
        firstname: Joi.string()
            .trim()
            .max(24)
            .required()
            .label('First Name'),
        lastname: Joi.string()
            .trim()
            .max(24)
            .required()
            .label('Last Name'),
        relationship: Joi.any()
            .optional()
            .label('Relationship'),
        location: Joi.string()
            .required()
            .label('Location Type'),
        company: Joi.any()
            .when('location', {
                is: 'Business',
                then: Joi.string().required(),
                otherwise: Joi.any().optional(),
            })
            .label('Company Name'),
        street: Joi.string()
            .trim()
            .max(100)
            .required()
            .label('Street Address'),
        apt: Joi.any()
            .optional()
            .label('Apt, Suite'),
        apofpo: Joi.any()
            .optional()
            .label('APO/FPO'),
        city: Joi.string()
            .trim()
            .max(50)
            .required()
            .label('City'),
        state: Joi.string()
            .alphanum()
            .required()
            .label('State'),
        zipcode: Joi.string()
            .trim()
            .regex(/^[a-zA-Z0-9-\s]+$/i, 'alphanumeric characters')
            .min(5)
            .max(10)
            .required()
            .label('Zip Code'),
        country: Joi.string()
            .alphanum()
            .required()
            .label('Country'),
        phone: Joi.string()
            .regex(/^[0-9]{10}$/i, '10 numeric characters')
            .allow('')
            .label('Phone Number'),
        isbilling: Joi.any().optional(),
        suggestedAddress: Joi.any().optional(),
    },
};

export default InputSchema;
